<template>
  <v-container fluid class="px-1 py-2">

    <div v-if="mode === 'dep'" class="title">Departures</div>
    <div v-if="mode === 'arr'" class="title">Arrivals</div>

    <div v-if="mode === 'starred'">
      <v-row no-gutters>
        <v-col>
          <span class="title">Starred</span>
        </v-col>
        <v-col cols="12" sm="8" md="6">
          <flight-events-select :items="allItems" v-model="selectedStarred"></flight-events-select>
        </v-col>
      </v-row>
    </div>

    <div v-if="mode === 'stand'">
      <v-row no-gutters>
        <v-col>
          <span class="title">By stands</span>
        </v-col>
        <v-col cols="12" sm="8" md="6">
          <stand-select :items="allStands" v-model="selectedStands"></stand-select>
        </v-col>
      </v-row>
    </div>


    <template v-for="item in visibleItems">
      <departure-and-arrival-item :value="item" :key="item.eventType + item.flight.id" @toggle="toggle"
        @toggleStarred="toggleStarEvent(item)" @moreInfo="openInfo(item, $event)" :now="now"
        :starred="starredItems.includes(item)" :expandedId="expandedId">
      </departure-and-arrival-item>
      <v-divider :key="'d' + item.eventType + item.flight.id" />
    </template>


    <v-dialog v-if="dialogEvent" v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-app-bar fixed dark color="primary" dense>
          <v-btn icon dark @click="closeInfo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <event-icon v-model="dialogEvent.data.eventType" />
            {{ dialogEvent.data.flight.number }}{{ dialogEvent.data.flight.suffix }}
            <span class="success--text">{{ dialogEvent.data.flight.actualDepApIata }}</span> -
            <span class="success--text">{{ dialogEvent.data.flight.actualArrApIata }}</span>
          </v-toolbar-title>
        </v-app-bar>
        <v-main>
          <flight-event-info v-if="dialogEvent.type === 'general'" :value="dialogEvent.data"></flight-event-info>
          <ldm-info v-if="dialogEvent.type === 'ldm'" :flightId="dialogEvent.data.flight.id"></ldm-info>
          <flight-connections v-if="dialogEvent.type === 'connections'" :value="dialogEvent.data"></flight-connections>
        </v-main>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import DepartureAndArrivalItem from '@/components/DepartureAndArrivalItem'
import FlightEventsSelect from '@/components/FlightEventsSelect'
import StandSelect from '@/components/StandSelect'
import FlightEventInfo from '@/components/FlightEventInfo'
import LdmInfo from '@/components/LdmInfo'
import EventIcon from '@/components/EventIcon'
import FlightConnections from "@/components/FlightConnections";

export default {
  name: 'DeparturesAndArrivals',
  components: { FlightEventInfo, LdmInfo, FlightConnections, DepartureAndArrivalItem, FlightEventsSelect, StandSelect, EventIcon },
  data: () => ({
    expandedId: null,
    dialogEvent: null,
    dialog: false
  }),
  computed: {
    ...mapState({
      isSocketAlive: state => state.arrivalsAndDepartures.isSocketAlive,
      isFeedAlive: state => state.arrivalsAndDepartures.isFeedAlive,
      itemsFilter: state => state.arrivalsAndDepartures.filter,
      now: state => state.app.now,
    }),
    ...mapGetters({
      allItems: 'arrivalsAndDepartures/allItems',
      arrItems: 'arrivalsAndDepartures/arrItems',
      depItems: 'arrivalsAndDepartures/depItems',
      starredItems: 'arrivalsAndDepartures/starredItems',
      standItems: 'arrivalsAndDepartures/standItems',
      allStands: 'arrivalsAndDepartures/allStands',
      oidcIsAuthenticated: 'oidcStore/oidcIsAuthenticated'
    }),
    mode() {
      let mode = this.$route.params.mode
      if (!['all', 'dep', 'arr', 'starred', 'stand'].includes(mode)) mode = 'all'
      return mode
    },
    visibleItems() {
      switch (this.mode) {
        case 'all':
          return this.allItems;
        case 'dep':
          return this.depItems;
        case 'arr':
          return this.arrItems;
        case 'starred':
          return this.starredItems;
        case 'stand':
          return this.standItems;
        default:
          return this.allItems;
      }
    },
    selectedStarred: {
      get() {
        return this.itemsFilter.starredEvents
      },
      set(value) {
        this.updateFilter({ ...this.itemsFilter, starredEvents: value })
      }
    },
    selectedStands: {
      get() {
        return this.itemsFilter.stands
      },
      set(value) {
        this.updateFilter({ ...this.itemsFilter, stands: value })
      }
    }
  },
  watch: {
    isSocketAlive: {
      handler(isFeedAlive) {
        if (!isFeedAlive && this.oidcIsAuthenticated) {
          setTimeout(() => this.requestStream(), 1000)
        }
      },
      immediate: true
    }
  },
  created() {
    this.initStore()
  },
  methods: {
    ...mapActions({
      'requestStream': 'arrivalsAndDepartures/requestStream',
      'updateFilter': 'arrivalsAndDepartures/updateFilter',
      'toggleStarEvent': 'arrivalsAndDepartures/toggleStarEvent',
      'initStore': 'arrivalsAndDepartures/initStore',
    }),
    toggle(id) {
      this.expandedId === id ? this.expandedId = null : this.expandedId = id
    },
    openInfo(event, type) {
      this.dialogEvent = { data: event, type: type }
      this.dialog = true
    },
    closeInfo() {
      this.dialogEvent = null
      this.dialog = false
    }
  }
}
</script>
